export default class SpecialIcons extends React.Component {
  constructor(props) {
    super(props);
    this.isNewYear = this.isNewYear.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  isNewYear() {
    if (this.props.is_new_year_offer) {
      return (
        <div className='card__thumb-icon'>
          <div className='icon icon-ny icon-ny-dims'
               title='У данной базы отдыха имеются новогодние предложения.'
          ></div>
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        {this.isNewYear()}
      </div>
    );
  }
}
